import * as z from 'zod';

import { audienceQuerySchema } from './audience-query-schema';

export const audienceUpdateSchema = audienceQuerySchema
  .pick({ id: true, name: true, plural: true })
  .extend({ status: z.string() });
export type AudienceUpdateSchema = z.infer<typeof audienceUpdateSchema>;

export const audienceCreateSchema = audienceUpdateSchema.omit({ id: true });
export type AudienceCreateSchema = z.infer<typeof audienceCreateSchema>;
